import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

const Header: React.FC = () => (
  <AppBar position="static">
    <Container maxWidth="xl">
      <Toolbar disableGutters>
        <Avatar
          alt="Manel Travels & Leisure Logo"
          src="logo.png"
          sx={{ mr: 1, width: 56, height: 56 }}
        />
        <Typography
          variant="h5"
          noWrap
          sx={{
            mr: 2,
            display: { md: 'flex' },
            flexGrow: 1,
            color: 'inherit',
            fontFamily: "'Josefin Sans', sans-serif",
            textDecoration: 'none',
          }}
        >
          Manel Travels & Leisure
        </Typography>
        <Stack direction="row" spacing={1}>
          <IconButton
            aria-label="facebook"
            color="secondary"
            onClick={() =>
              window.open(
                'https://www.facebook.com/profile.php?id=100093861736625'
              )
            }
          >
            <FacebookIcon />
          </IconButton>
          <IconButton
            aria-label="instagram"
            color="secondary"
            onClick={() =>
              window.open('https://www.instagram.com/manel.travels')
            }
          >
            <InstagramIcon />
          </IconButton>
        </Stack>
      </Toolbar>
    </Container>
  </AppBar>
);

export default Header;
